import * as THREE from 'three'
import Stats from 'three/addons/libs/stats.module.js'

export interface SceneContext {
  scene: THREE.Scene
  camera: THREE.PerspectiveCamera
  renderer: THREE.WebGLRenderer
  stats: Stats
}

export function createSceneContext(width: number, height: number, testMode: boolean): SceneContext {
  const stats = new Stats()
  if (!testMode) {
    document.body.appendChild(stats.dom)
  }

  const scene = new THREE.Scene()
  scene.background = new THREE.Color(0x1a1d22)

  const camera = new THREE.PerspectiveCamera(75, width / height, 0.2, 1000)

  const renderer = new THREE.WebGLRenderer({ antialias: true, logarithmicDepthBuffer: true })
  renderer.setSize(width, height)
  renderer.setPixelRatio(testMode ? 1 : window.devicePixelRatio)
  document.body.appendChild(renderer.domElement)

  scene.add(new THREE.HemisphereLight(0xffffff, 0x666666, 2.5))
  const sun = new THREE.DirectionalLight(0xffffff, 2.5)
  sun.position.set(10, 20, 5)
  scene.add(sun)

  if (!testMode) {
    window.addEventListener('resize', () => {
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()
      renderer.setSize(window.innerWidth, window.innerHeight)
    })
  }

  return { scene, camera, renderer, stats }
}
